var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerPaymentActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#8B308D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.265 12.617h-.816v.823h.816v-.823z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.898 8.914H7.102V7.68h8.98v-.823h-8.98a.813.813 0 0 0-.577.24.826.826 0 0 0-.239.583v8.64c0 .218.086.427.24.582.152.154.36.24.576.24h9.796a.813.813 0 0 0 .578-.24.826.826 0 0 0 .239-.582V9.737a.826.826 0 0 0-.24-.582.813.813 0 0 0-.577-.24zM7.102 16.32V9.737h9.796v1.234h-3.265a.813.813 0 0 0-.577.241.827.827 0 0 0-.24.582v2.469c0 .218.087.427.24.582.153.154.36.24.577.24h3.265v1.235H7.102zm9.796-4.526v2.469h-3.265v-2.469h3.265z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPaymentActiveIcon);
export default __webpack_public_path__ + "static/media/customerPaymentActiveIcon.d89a7abce3f9621c0b9d52a484c0fb60.svg";
export { ForwardRef as ReactComponent };